import forgotCredentialsModule from '../forgotCredentialsModule';
import { EnvironmentUrls, ExperimentationService } from "Roblox";

function forgotCredentialsService(httpService, forgotCredentialsConstants) {
    "ngInject";
    var apiAuth;

    function getPhoneTarget(prefix, phone, countryCode) {
        return (prefix + "," + phone + "," + countryCode).replace(/\s/g, "");
    }

    var forgotCredentialsService = {
        getMetadata: function () {
            const url = EnvironmentUrls.authApi + forgotCredentialsConstants.urls.getMetadata;
            const urlConfig = {
                url: url
            };

            return httpService.httpGet(urlConfig);
        },
        sendResetPasswordForEmail: function (email) {
            const url = apiAuth + forgotCredentialsConstants.urls.sendPasswordReset;
            const urlConfig = {
                url: url
            };

            const params = {
                targetType: forgotCredentialsConstants.targetTypes.email,
                target: email
            };

            return httpService.httpPost(urlConfig, params);
        },
        sendResetPasswordForPhone: function (prefix, phone, countryCode, captchaData) {
            const url = apiAuth + forgotCredentialsConstants.urls.sendPasswordReset;
            const urlConfig = {
                url: url
            };

            const target = getPhoneTarget(prefix, phone, countryCode);

            const params = {
                targetType: forgotCredentialsConstants.targetTypes.phoneNumber,
                target: target
            };
            if (captchaData != null) {
                params.captchaId = captchaData.captchaId;
                params.captchaToken = captchaData.captchaToken;
                params.captchaProvider = captchaData.captchaProvider;
            }

            return httpService.httpPost(urlConfig, params);
        },
        verifyCode: function (nonce, code) {
            const url = apiAuth + forgotCredentialsConstants.urls.verifyCode;
            const urlConfig = {
                url: url
            };

            const params = {
                targetType: forgotCredentialsConstants.targetTypes.phoneNumber,
                nonce: nonce,
                code: code
            };

            return httpService.httpPost(urlConfig, params);
        },
        setAuthApi: function (url) {
            apiAuth = url;
        },
        captcha: {
            captchaPassed: angular.noop,
            captchaFailed: angular.noop,
            returnTokenInSuccessCb: false
        }
    };
    return forgotCredentialsService;
}

forgotCredentialsModule.
    factory("forgotCredentialsService", forgotCredentialsService);

export default forgotCredentialsService;
